<template>
  <div class="recruit-container" ref="recruit-container" :style="{
    'background-image': `url(${gc.section_bg.top}), url(${gc.section_bg.mid}), url(${gc.section_bg.bot})`,
    'margin-top': cc.margin_top + 'px' || gc.margin_top + 'px',
    'margin-bottom': cc.margin_bot + 'px' || gc.margin_bot + 'px',
    }">
    <div class="head-box">
      <p class="task-desc" :style="{'color': hexToRgba(gc.main_color, .8)}">{{cc.tip_desc}}</p>
      <div :class="`awards ${awardsClass}`">
        <div class="award" :class="{'arrow': award === 'arrow'}" v-for="award in awards" :key="award.title">
          <template v-if="award !== 'arrow'">
            <div class="award-inner" @click="getAward(award)" :style="{'opacity': award.state == 1 ? '.7' : '1', 'background-color': cc.tip_color}">
              <div class="img-box">
                <img :src="award.img_url" alt="">
                <img v-if="award.state == 1" src="https://imgheybox.max-c.com/oa/2022/01/10/c3f386b76784933bc54d8a2a9ecc0c1a.png" alt="" class="received">
              </div>
              <div class="title" :style="{'color': gc.main_color}">{{award.title}}</div>
            </div>
            <p class="award-desc" :style="{'color': hexToRgba(gc.main_color, .7)}">{{award.desc}}</p>
          </template>
          <svg v-else width="11" height="8" viewBox="0 0 11 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M5.38056 0.697242C5.21326 0.855247 5.20573 1.11896 5.36374 1.28626L7.92687 4.00016L5.36374 6.71407C5.20573 6.88137 5.21326 7.14508 5.38056 7.30309C5.54786 7.46109 5.81157 7.45356 5.96958 7.28626L8.80291 4.28626C8.95457 4.12568 8.95457 3.87465 8.80291 3.71407L5.96958 0.714071C5.81157 0.546771 5.54786 0.539237 5.38056 0.697242Z" :fill="cc.tip_color"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M2.38056 0.697242C2.21326 0.855247 2.20573 1.11896 2.36374 1.28626L4.92687 4.00016L2.36374 6.71407C2.20573 6.88137 2.21326 7.14508 2.38056 7.30309C2.54786 7.46109 2.81157 7.45356 2.96958 7.28626L5.80291 4.28626C5.95457 4.12568 5.95457 3.87465 5.80291 3.71407L2.96958 0.714071C2.81157 0.546771 2.54786 0.539237 2.38056 0.697242Z" :fill="cc.tip_color"/>
          </svg>
        </div>
      </div>
    </div>
    <!-- <div class="divider" :style="{'background-color': hexToRgba('#282828', .3)}"></div> -->
    <div class="task-box" ref="task-box">
      <div class="btn" @click="invite" :style="{'background-image': `url(${cc.btn_bg || gc.btn_bg})`, 'color': gc.text_color}">{{`立即邀请（已邀请${cd.users.length}/${cd.invite_limit}）`}}</div>
      <div class="user-list">
        <div class="user" :ref="`user-${user_index}`" v-for="(user, user_index) in cd.users" :key="user.heybox_id">
          <div class="user-info" @click="changeActive(user_index)" :style="{'background-color': hexToRgba(cc.tip_color, user_index % 2 == 0 ? .2 : .1)}">
            <div class="avatar">
              <img :src="user.avatar" alt="">
            </div>
            <div class="username">{{user.username}}</div>
            <div class="task-desc">
              <p :style="{'color': hexToRgba(gc.main_color, .7)}">任务进度：{{`${user.task_state.filter(item => item != 0).length}/${cd.tasks.length}`}}</p>
              <svg :class="{'reverse': max_heights[user_index] !== 0}" width="12" height="5" viewBox="0 0 12 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path opacity="0.7" d="M6 0L12 5L0 5L6 0Z" :fill="gc.main_color"/>
              </svg>
            </div>
          </div>
          <div class="task-list" :style="{'max-height': max_heights[user_index] + 'px'}">
            <div class="task" v-for="(task, index) in cd.tasks" :key="task.task_id">
              <div class="icon">
                <img :src="task.img" alt="">
              </div>
              <div class="right-box" :style="{'border-bottom': index === cd.tasks.length - 1? '' : `1px solid ${hexToRgba(gc.main_color, 0.1)}`}">
                <div class="info-box">
                  <div class="title" :style="{'color': gc.main_color}">
                    <div class="descr">{{task.name}}</div>
                    <div class="icon-question">
                      <svg v-if="task.explanation" :ref="`taskTip-${index}`" @click.stop="showTaskTip(user.heybox_id + task.id)" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M1.925 7C1.925 4.19715 4.19715 1.925 7 1.925C9.80285 1.925 12.075 4.19715 12.075 7C12.075 9.80285 9.80285 12.075 7 12.075C4.19715 12.075 1.925 9.80285 1.925 7ZM7 0.875C3.61726 0.875 0.875 3.61726 0.875 7C0.875 10.3827 3.61726 13.125 7 13.125C10.3827 13.125 13.125 10.3827 13.125 7C13.125 3.61726 10.3827 0.875 7 0.875ZM7.4266 9.52151H6.48855V10.5H7.4266V9.52151ZM5.47508 4.12097C5.09169 4.53181 4.9 5.07594 4.9 5.75336H5.73906C5.75477 5.34565 5.81919 5.0336 5.93232 4.8172C6.13345 4.42832 6.49641 4.23387 7.02121 4.23387C7.44545 4.23387 7.74871 4.34677 7.93098 4.57258C8.11639 4.79839 8.20909 5.06496 8.20909 5.37231C8.20909 5.59185 8.14624 5.80354 8.02054 6.00739C7.9514 6.12343 7.86027 6.23477 7.74714 6.3414L7.37003 6.71304C7.00864 7.06743 6.77452 7.38262 6.66768 7.6586C6.56083 7.93145 6.50741 8.29211 6.50741 8.74059H7.34646C7.34646 8.34543 7.39046 8.04749 7.47845 7.84677C7.56958 7.64292 7.76599 7.39516 8.06768 7.10349C8.48249 6.70206 8.75746 6.39785 8.89259 6.19086C9.03086 5.98387 9.1 5.71416 9.1 5.38172C9.1 4.83289 8.91302 4.38284 8.53906 4.03159C8.16824 3.6772 7.67329 3.5 7.05421 3.5C6.38485 3.5 5.85847 3.70699 5.47508 4.12097Z" :fill="gc.main_color"/>
                      </svg>
                      <template v-if="task.explanation && showExplanationIndex === user.heybox_id + task.id">
                        <svg @click.stop="" class="arrow" width="6" height="3" viewBox="0 0 6 3" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M6 3H0L3 0L6 3Z" :fill="hexToRgba(cc.tip_color || gc.main_color, .9)"/>
                        </svg>
                        <div @click.stop="" class="explanation-modal" :style="{
                          'background-color': hexToRgba(cc.tip_color || gc.main_color, .9), 
                          'color': gc.text_color, 
                          'left': taskTipPos.left,
                          'top': taskTipPos.top
                          }">
                          {{task.explanation}}
                        </div>
                      </template>
                    </div>
                  </div>
                  <p class="finish-desc" :style="{'color': gc.main_color, 'opacity': '.6'}" v-if="task.finish_desc">{{task.finish_desc}}</p>
                  <div class="score-box">
                    <span class="score-icon" :style="{'background-image': `url(${cc.score_icon})`}" v-if="cc.score_icon"></span>
                    <svg v-else width="11" height="10" viewBox="0 0 11 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M9.20745 6.65905C9.35427 6.86797 9.42855 7.08592 9.42855 7.30827C9.42855 8.39871 7.66622 9.28578 5.49998 9.28578C3.33374 9.28578 1.57141 8.39871 1.57141 7.30827C1.57141 7.08592 1.6457 6.86797 1.79252 6.65905C2.48319 7.39725 3.91684 7.8685 5.49998 7.8685C7.08313 7.8685 8.51678 7.39725 9.20745 6.65905ZM9.18386 4.31816C9.34632 4.53693 9.42855 4.76587 9.42855 5.00004C9.42855 6.09049 7.66622 6.97756 5.49998 6.97756C3.33374 6.97756 1.57141 6.09049 1.57141 5.00004C1.57141 4.76587 1.65365 4.53693 1.81611 4.31816C2.5153 5.04111 3.94058 5.50287 5.49998 5.50287C7.05938 5.50287 8.48466 5.04111 9.18386 4.31816ZM5.49998 0.714355C7.66622 0.714355 9.42855 1.60143 9.42855 2.69182C9.42855 3.78226 7.66622 4.66934 5.49998 4.66934C3.33374 4.66934 1.57141 3.78226 1.57141 2.69182C1.57141 1.60143 3.33374 0.714355 5.49998 0.714355Z" :fill="gc.main_color"/>
                    </svg>
                    <span class="score-desc" :style="{'color': gc.main_color}">{{task.award_desc}}</span>
                  </div>
                </div>
                <div class="finish-btn" :style="{'opacity': ['', '.72'][user.task_state[index]], 'color': gc.main_color}">
                  {{['未完成', '已完成'][user.task_state[index]]}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Modal ref="success-modal" :width="299" :gc="gc" :cc="cc" title="领取成功">
      <div class="success-modal-wrapper modal-content">
        <div class="modal-item">
          <div class="image-box">
            <img :src="award.img_url" alt="">
          </div>
          <p class="prize-name" :style="{'color': gc.main_color}">{{award.title}}</p>
        </div>
        <p class="distribute-desc" :style="{'color':  hexToRgba(gc.main_color, .8)}">{{notify_content}}</p>
        <div class="btn-done" @click="closeSuccessModal" :style="{'background': cc.modal_confirm_btn_big || gc.modal_confirm_btn_big ? `url(${cc.modal_confirm_btn_big || gc.modal_confirm_btn_big}) no-repeat center/contain` : '#0B8AFF', 'color': gc.text_color,'margin-top': '10px'}">确认</div>
      </div>
    </Modal>
    <Modal ref="faild-modal" :width="299" :gc="gc" :cc="cc" title="领取失败">
      <div class="faild-modal-wrapper modal-content">
        <p class="faild-desc" :style="{'color':  hexToRgba(gc.main_color, .6)}">{{notify_content}}</p>
        <div class="btn-wrapper">
          <div class="btn btn-cancel"  :style="{'background': cc.modal_cancel_btn || gc.modal_cancel_btn ? `url(${cc.modal_cancel_btn || gc.modal_cancel_btn}) no-repeat center/contain` : '#0B8AFF', 'color': gc.text_color}" @click="closeFaildModal">取消</div>
          <div class="btn btn-confirm" :style="{'background': cc.modal_confirm_btn_small || gc.modal_confirm_btn_small ? `url(${cc.modal_confirm_btn_small || gc.modal_confirm_btn_small}) no-repeat center/contain` : '#0B8AFF', 'color': gc.text_color}" @click="closeFaildModal">确认</div>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import { utils } from '_lib/utils'
import { ComponentCommonMixin } from '../mixin'
import { recruit } from '_api/activity-common-template'

export default {
  name: 'cpt-new-user',
  mixins: [ComponentCommonMixin],
  data () {
    return {
      active_index: -1,
      showExplanationIndex: -1,
      max_heights: [],
      award_num: 0,
      awards: [],
      awardsClass: '',
      award: {},
      notify_content: '请在我的钱包-我的卡券中查看'
    }
  },
  mounted () {
    let awards = this.cd.key_cnt_awards
    // let awards = [...this.cd.key_cnt_awards, ...utils.deepCopy(this.cd.key_cnt_awards).splice(0, 1)]
    this.awardsClass = this.calcClass(utils.deepCopy(awards))
    awards.forEach((item, index) => {
      this.awards.push(Object.assign(item, {
        index
      }), 'arrow')
    })
    this.awards.splice(this.awards.length - 1, 1)
    document.body.addEventListener('click', () => {
      if (this.showExplanationIndex !== -1) {
			  this.showExplanationIndex = -1
      }
		}, false)
    this.task_list_height = 65 * this.cd.tasks.length
    this.max_heights = this.cd.users.map((item, index) => index === 0 ? this.task_list_height : 0)
  },
  methods: {
    changeActive (index) {
      if (this.max_heights[index] === 0) {
        this.$set(this.max_heights, index, this.task_list_height)
        setTimeout(() => {
          const obj = document.querySelector('.task-box .user-list').getBoundingClientRect()
          if (window.innerHeight - obj.y < obj.height) {
            this.scrollTo(document.scrollingElement, document.scrollingElement.scrollTop - (window.innerHeight - obj.y - obj.height - 100))
          }
        }, 150)
      } else {
        this.$set(this.max_heights, index, 0)
      }
    },
    invite () {
      if (!this.is_in_heybox) {
        this.openInHeybox()
        return
      }
      utils.executeProtocol(this.cd.protocol)
    },
    showTaskTip (index) {
      this.showExplanationIndex = index
      const elPos = this.$refs[`taskTip-${index}`][0].getBoundingClientRect()
      this.taskTipPos = {
        left: '-' + (elPos.x / screen.width) * 1000+ '%',
      }
    },
    calcClass (awards) {
      if (awards.length === 2 || awards.length === 3) {
        return 'two'
      }
      return ''
    },
    getAward (award) {
      if (!this.is_in_heybox) {
        this.openInHeybox()
        return
      }
      if (award.index >= this.cd.key_user_cnt || award.state == 1) {
        return
      }
      this.award = award
      recruit({
        act_id: this.act_id || this.querys.act_id,
        award_id: award.value,
        heybox_id: this.querys.heybox_id
      }).then(res => {
        if (res.data.status === 'ok') {
          this.notify_content = '请在我的钱包-我的卡券中查看'
          this.showSuccessModal()
          award.state = 1
        } else {
          // this.notify_content = res.data.msg
          utils.showMessage('faild', res.data.msg)
          // this.showFaildModal()
        }
      })
    },
    scrollTo (el, pos){
      const gap = el.scrollTop
      const delta = pos - gap
      let speed = delta / 6
      if (speed === this.speed) {
        return
      }
      this.speed = speed
      speed = Math.floor(speed)
      if (delta !== 0) {
        el.scrollTo(0, gap + speed)
        setTimeout(() => {
          this.scrollTo(el, pos)
        }, 17)
      }
    },
    showSuccessModal () {
      this.$refs['success-modal'].showModal()
    },
    closeSuccessModal () {
      this.$refs['success-modal'].hideModal()
    },
    showFaildModal () {
      this.$refs['faild-modal'].showModal()
    },
    closeFaildModal () {
      this.$refs['faild-modal'].hideModal()
    }
  }
}
</script>

<style lang="less">
.recruit-container {
  margin: 32px 14px 0;
  background-size: 100% 30px, 100% calc(100% - 60px), 100% 30px;
  background-repeat: no-repeat;
  background-position: center top, center center, center bottom;
  .head-box {
    padding: 20px 18px 0;
    .task-desc {
      font-size: 13px;
      line-height: 18px;
      text-align: center;
      letter-spacing: -0.3px;
      margin-bottom: 16px;
    }
    .awards {
      display: flex;
      align-items: center;
      justify-content: space-around;
      &.two {
        justify-content: center;
        .arrow {
          flex: 0
        }
      }
      .award {
        position: relative;
        flex: 1;
        &.arrow {
          width: auto;
          bottom: 15px;
          display: flex;
          justify-content: center;
        }
        .award-inner {
          margin: 0 auto 8px;
          position: relative;
          width: calc(13.333vw);
          max-width: 64px; // 按照13.333vw同比例，按照480px为最大宽度计算得出
          .img-box {
            width: calc(100% - 2px);
            height: 0;
            padding-bottom: 80%;
            margin: 1px auto 2px;
            position: relative;
            top: 1px;
            flex-shrink: 0;
            background-color: #FFF;
            img {
              position: absolute;
              left: 0;
              top: 0;
              width: 100%;
              height: 100%;
            }
          }
          .title {         
            text-align: center;
            font-size: 17px;
            line-height: 24px;
            padding: 0 2px 6px;
            font-weight: 600;
            zoom: .5;
            word-break: break-all;
            white-space: nowrap;
            overflow: hidden;
          }
          .left-count {
            position: absolute;
            top: 0;
            right: 1px;
            padding: 3px;
            line-height: 22px;
            font-size: 24px;
            transform: scale(.5);
            transform-origin: right top;
          }
          
        }
        .award-desc {
          font-size: 11px;
          line-height: 15px;
          text-align: center;
          white-space: nowrap;
        }
      }
      
    }
  }
  .task-box {
    margin-top: 12px;
    padding-bottom: 2px;
    .btn {
      font-weight: 500;
      font-size: 15px;
      line-height: 44px;
      height: 44px;
      width: calc(100% - 36px);
      margin: 0 auto 16px;
      text-align: center;
      color: #FEFEFE;
      background-repeat: no-repeat;
      background-position: center;
      background-size: cover;
    }
    .user-list {
      margin: 0 18px;
      .user {
        transition: all 0.35s cubic-bezier(0.24, 0.01, 0.24, 1);
        overflow: hidden;
        .user-info {
          display: flex;
          align-items: center;
          height: 52px;
          padding: 0 16px;
          .avatar {
            width: 38px;
            height: 38px;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .username {
            flex: 1;
            margin: 0 18px;
            font-weight: 500;
            font-size: 13px;
            line-height: 18px;
            color: #FFFFFF;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .task-desc {
            display: flex;
            align-items: center;
            height: 100%;
            p {
              font-size: 13px;
              line-height: 18px;
              margin-right: 6px;
            }
            svg {
              position: relative;
              bottom: 2px;
              transition: transform 0.35s cubic-bezier(0.24, 0.01, 0.24, 1);
              &.reverse {
                transform: rotate(180deg);
              }
            }
          }
        }
        .task-list {
          padding: 0 18px;
          transition: all 0.35s cubic-bezier(0.24, 0.01, 0.24, 1);
          .task {
            display: flex;
            align-items: center;
            position: relative;
            .icon {
              height: 28px;
              width: 28px;
              img {
                width: 100%;
                height: 100%;
                display: block;
                object-fit: contain;
              }
            }
            .right-box {
              display: flex;
              justify-content: space-between;
              flex: 1;
              margin: 0 10px;
              padding: 12px 0 11px;
              .info-box {
                flex: 1;
                width: 0;
                .title {
                  margin-bottom: 1px;
                  position: relative;
                  .descr {
                    display: inline;
                    font-weight: 500;
                    font-size: 14px;
                    line-height: 20px;
                    width: 90%;
                  }
                  .icon-question {
                    margin-left: 3px;
                    position: relative;
                    top: 1px;
                    display: inline;
                    width: 10%;
                  }
                  .arrow {
                    position: absolute;
                    right: 3px;
                    bottom: 0;
                    z-index: 10;
                  }
                  .explanation-modal {
                    width: 50vw;
                    max-width: 240px;
                    top: 19px;
                    position: absolute;
                    z-index: 10;
                    padding: 10px;
                    line-height: 18px;
                    text-align: center;
                    font-size: 12px;
                  }
                }
                .finish-desc, .score-box .score-desc {
                  font-size: 11px;
                  line-height: 15px;
                }
                .score-box {
                  display: flex;
                  align-items: center;
                  margin-top: 2px;
                  opacity: 0.6;
                  .score-icon {
                    width: 12px;
                    height: 12px;
                    margin-right: 4px;
                    background-repeat: no-repeat;
                    background-size: contain;
                    background-position: center center;
                  }
                }
              }
              .finish-btn {
                font-weight: 500;
                font-size: 14px;
                line-height: 26px;
                text-align: center;
              }
            }
          }
        }
      }
    }
  }
  .success-modal-wrapper {
    .modal-item {
      .image-box {
        width: 94px;
        height: 74px;
        position: relative;
        overflow: hidden;
        margin: 14px auto;
        border-radius: 2px;
        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
      .prize-name {
        font-size: 13px;
        line-height: 16px;
        max-width: 100%;
        text-align: center;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
  .faild-modal-wrapper {
    .faild-desc {
      font-weight: 500;
      font-size: 14px;
      line-height: 20px;
      text-align: center;
      margin: 14px auto 18px;
    }
    .btn-wrapper {
      display: flex;
      justify-content: center;
      .btn {
        width: calc(100% - 9px); 
        height: 36px;
        text-align: center;
        line-height: 36px;
        font-weight: 500;
        font-size: 15px;
        letter-spacing: .25px;
      }
      .btn-cancel {
        margin-right: 9px;
      }
    }
  }
}
</style>